(function () {
  const SOLD_OUT_WORDS = ['agotado', 'sin stock', 'no disponible', 'sold out', 'out of stock'];

  function findScopeRoot(el) {
    // sube hasta un contenedor razonable de producto
    return (
      el.closest('product-form-component') ||
      el.closest('.product') ||
      el.closest('[data-section-id]') ||
      el.closest('section') ||
      document
    );
  }

  function findAddButton(scope) {
    return (
      scope.querySelector('button[name="add"]') ||
      scope.querySelector('form[action*="/cart/add"] button[type="submit"]') ||
      scope.querySelector('button[type="submit"][name="add"]') ||
      null
    );
  }

  function isSoldOutByButton(btn) {
    if (!btn) return null;

    if (btn.hasAttribute('disabled')) return true;

    const aria = btn.getAttribute('aria-disabled');
    if (aria && aria.toLowerCase() === 'true') return true;

    const txt = (btn.textContent || '').trim().toLowerCase();
    if (SOLD_OUT_WORDS.some(w => txt.includes(w))) return true;

    // A veces el theme pone data-available="false" o similares
    const dataAvail = btn.getAttribute('data-available');
    if (dataAvail && dataAvail.toLowerCase() === 'false') return true;

    return false;
  }

  function toggleForBlock(block) {
    // soporta guion y underscore
    const inEl =
      block.querySelector('[data-monak-stock="in"]') ||
      block.querySelector('[data-monak_stock="in"]');

    const outEl =
      block.querySelector('[data-monak-stock="out"]') ||
      block.querySelector('[data-monak_stock="out"]');

    // Si el "in/out" no está dentro del mismo contenedor, los buscamos global dentro del bloque padre
    const parent = block.closest('.monak-key-features') || block.parentElement || document;

    const inReal =
      inEl ||
      parent.querySelector('[data-monak-stock="in"], [data-monak_stock="in"]');

    const outReal =
      outEl ||
      parent.querySelector('[data-monak-stock="out"], [data-monak_stock="out"]');

    if (!inReal || !outReal) return;

    const scope = findScopeRoot(parent);
    const btn = findAddButton(scope);

    const soldOut = isSoldOutByButton(btn);
    if (soldOut === null) return;

    inReal.style.display = soldOut ? 'none' : '';
    outReal.style.display = soldOut ? '' : 'none';
  }

  function bindObserversForScope(scope) {
    const btn = findAddButton(scope);
    if (btn) {
      const mo = new MutationObserver(() => {
        document.querySelectorAll('.monak-key-features').forEach(block => toggleForBlock(block));
      });
      mo.observe(btn, { attributes: true, childList: true, subtree: true });
    }

    const variantInput = scope.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"]');
    if (variantInput) {
      const mo2 = new MutationObserver(() => {
        document.querySelectorAll('.monak-key-features').forEach(block => toggleForBlock(block));
      });
      mo2.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    }
  }

  function init() {
    // 1) Toggle inicial
    document.querySelectorAll('.monak-key-features').forEach(block => toggleForBlock(block));

    // 2) Bind por cada producto visible
    document.querySelectorAll('product-form-component, .product, [data-section-id]').forEach(scope => {
      bindObserversForScope(scope);
    });

    // 3) Fallback global al cambiar selects/radios
    document.addEventListener('change', () => {
      setTimeout(() => {
        document.querySelectorAll('.monak-key-features').forEach(block => toggleForBlock(block));
      }, 60);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
